import { css, cx } from 'linaria';
import { cssTheme, hex2RgbString, Colorway } from '@uds/theme-utils';
import { Layout } from 'domain/constants/layout';
import { Alignment } from 'domain/constants/alignment';

interface Props {
  colorway: Colorway;
  layout: Layout;
  duoLayout: boolean | undefined;
  hasTiles: boolean | undefined;
}

const root = css`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;

  background: rgba(var(--wash-color), var(--wash-opacity));

  ${cssTheme.breakpoints.md} {
    background: linear-gradient(
      to right,
      rgba(var(--wash-color), 0.9) 40%,
      rgba(var(--wash-color), 0.8) 50%,
      rgba(var(--wash-color), 0) 65%
    );
  }
`;

const washOpacity = css`
  --wash-opacity: 0.75;
`;

const lightWashOpacity = css`
  --wash-opacity: 0.9;
`;

const wash = css`
  background: rgba(var(--wash-color), var(--wash-opacity));
`;

const washColor: Record<Colorway, string> = {
  LIGHT: css`
    --wash-color: ${hex2RgbString('#fff')};
  `,
  NEUTRAL: css`
    --wash-color: ${cssTheme.palette.rgb.grey10};
  `,
  DARK: css`
    --wash-color: ${hex2RgbString('#000')};
  `,
  PRIMARY: css`
    --wash-color: ${cssTheme.palette.rgb.primary};
  `,
  PRIMARY_GRADIENT: css`
    --wash-color: ${cssTheme.palette.rgb.primary};
  `,
  HIGHLIGHT: css`
    --wash-color: ${cssTheme.palette.rgb.highlight};
  `,
};

export const getClassNames = ({ colorway, layout, duoLayout, hasTiles }: Props) => {
  /*
    Creates a gradient or semi opaque wash.
    Use the wash on:
    - mobile
    - we're center aligned text
    - we're a duo layout
    - we have tiles
    Use gradient otherwise
  */
  const useWash = layout.alignment === Alignment.CENTER || duoLayout === true || hasTiles === true;

  return {
    root: cx(root, washColor[colorway], colorway === Colorway.LIGHT ? lightWashOpacity : washOpacity, useWash && wash),
  };
};
